import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

// Sign-in screen: brand panel on the left, the form on the right. After signing in, the user
// lands on the page they were trying to open (or Home).
export default function Login() {
  const auth = useAuth();
  const go = useNavigate();
  const from = useLocation().state?.from || '/';
  const [who, setWho] = useState('');
  const [secret, setSecret] = useState('');
  const [working, setWorking] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setWorking(true);
    const ok = await auth.login(who.trim(), secret);
    setWorking(false);
    if (ok) go(from, { replace: true });
  };

  return (
    <div className="auth-page">
      <aside className="auth-brand">
        <img src="/images/dugoutscout.png" alt="" />
        <h1>Dugout Scout</h1>
        <p>Game reports, scouting cards and player development for your program.</p>
      </aside>

      <form className="auth-form" onSubmit={onSubmit} noValidate>
        <h2>Sign in</h2>
        <p className="auth-hint">Use the email or username your program admin gave you.</p>

        {auth.authError && <div className="auth-error" role="alert">{auth.authError}</div>}

        <label htmlFor="auth-who">Email or username</label>
        <input id="auth-who" autoComplete="username" autoFocus value={who} onChange={(e) => setWho(e.target.value)} />

        <label htmlFor="auth-secret">Password</label>
        <input id="auth-secret" type="password" autoComplete="current-password" value={secret} onChange={(e) => setSecret(e.target.value)} />

        <button type="submit" disabled={working || !who.trim() || !secret}>
          {working ? 'Signing in…' : 'Sign in'}
        </button>
        <small>Authorized users only.</small>
      </form>
    </div>
  );
}
